import { useAuth } from "../auth/AuthContext";

/** Maya as her own posts and cards show her. */
export function useHost(): { name: string; photo: string | null } {
  const { user } = useAuth();
  return { name: user ? `${user.first_name} ${user.last_name}`.trim() || "You" : "You", photo: user?.avatar_url ?? null };
}
